












































































































































































import jQuery from 'jquery';
import { Component, Prop, Vue } from 'vue-property-decorator';
import RadioField from '@/components/Form/RadioField.vue';
import SelectField from '@/components/Form/SelectField.vue';
import WarningMessageModal from '@/components/Modal/Mmic/IncludeClaimantWarningMessage.vue';
import {
	AsyncNotifications,
	NotifyListener,
	Message,
	notify,
	NotifyEvent,
} from '@/services/AsyncNotifications';
import { PolicyPacket } from '@/services/PolicyDocuments';
import Reports, { ClaimantNameOption, PceOption } from '@/services/Reports';
import MmicLossHistoryReportItem from './MmicLossHistoryReportItem.vue';
import { LossReport } from './ReportTypes';

@Component({
	components: {
		MmicLossHistoryReportItem,
		RadioField,
		SelectField,
		WarningMessageModal,
	},
})
export default class MmicLossHistoryReportList extends Vue {
	@Prop() private readonly reports: LossReport[];
	@Prop() private readonly reportType: string;

	private filterText: string = '';
	private filteredReports: LossReport[] = [];
	private paginate: string[] = ['filteredReports'];

	private readonly PceOption = PceOption;
	private pceOption: PceOption = PceOption.exclude;

	private readonly ClaimantNameOption = ClaimantNameOption;
	private claimantName: ClaimantNameOption = ClaimantNameOption.exclude;

	private perPage: number = 15;

	private created(): void {
		this.filterReports();
	}

	private filterReports(): void {
		if (!this.filterText) {
			this.filteredReports = this.reports.slice();
		} else {
			const regex = new RegExp(this.filterText, 'gi');
			this.filteredReports = this.reports.filter(
				(report: LossReport): boolean =>
					!!report.policy_no.match(regex) || !!report.policy_holder_name.match(regex),
			);
		}
	}

	private showWarning(): void {
		jQuery('#claimantWarningMessage').modal('show');
	}
}
